/**
 * Demo / "auth disabled" mode for the SPA.
 *
 * Activated at build time via `VITE_AUTH_DISABLED=1`. When active:
 *   - `RequireAuth` renders its children directly (no Clerk session check).
 *   - `HomeRedirect` jumps straight to /app/today instead of the landing.
 *   - `/sign-in` and `/sign-up` redirect to /app/today.
 *
 * Pair with the API-side `AUTH_DISABLED=1` flag — the backend resolves
 * every request to the same shared demo user, so no header is needed
 * from the SPA.
 *
 * NEVER bundle this for the real production deployment.
 */
const ENV_FLAG =
  typeof import.meta !== "undefined" &&
  (import.meta as { env?: Record<string, string | undefined> }).env
    ?.VITE_AUTH_DISABLED === "1";

export function isAuthDisabled(): boolean {
  return ENV_FLAG;
}
